import _ from "lodash";
import React from "react";
import { Link, useMatch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { useMount, useForceUpdate } from "@sportal/cdk/hooks";
import { useLoadableSlice } from "../../../store/shared/withLoadingState";
import { useIntlTranslate } from "../../../hooks";
import { loadLogicalDevices } from "../../../store/devices/logical";
import { getLines, getLogicalDevices } from "../../../store/root.selectors";
import { loadLines } from "../../../store/devices/lines";
import { loadRequests } from "../../../store/devices/requests";
import { getNewRequests } from "../../../store/devices";
import { Notification } from "../notification/Notification";
import { hasMultipleSupport } from "../../../store/info";

const NewRequestsNotificationContent = ({ onClick }) => {
  const dispatch = useDispatch();
  const translate = useIntlTranslate();

  useLoadableSlice(loadLogicalDevices(), getLogicalDevices);
  useLoadableSlice(loadLines(), getLines);
  useMount(() => {
    dispatch(loadRequests());
  });

  const { withName, withCode, discovered } = useSelector(
    getNewRequests,
    _.isEqual
  );

  const requestsAmount = _.size(withName);
  const devicesAmount = _.size(withCode) + _.size(discovered);

  if (requestsAmount === 0 && devicesAmount === 0) {
    return null;
  }

  return (
    <Notification
      key="new-requests-notification"
      id="new-requests-notification"
      variant="info"
      description={{
        id: "new_requests_notification",
        values: {
          requestsAmount: requestsAmount,
          devicesAmount: devicesAmount,
          hasBoth: !!(requestsAmount && devicesAmount),
          a: (text) => (
            <Link
              to="/settings/devices"
              aria-label={translate("aria_link_to_page", {
                linkText: text,
                pageName: translate("devices"),
              })}
            >
              {text}
            </Link>
          ),
        },
      }}
      onClick={onClick}
    />
  );
};

const makeDismissable = () => {
  let isDismissed = false;

  return ({ children }) => {
    const forceUpdate = useForceUpdate();
    const dismiss = () => {
      isDismissed = true;
      forceUpdate();
    };

    return isDismissed ? null : children(dismiss);
  };
};

const Dismissable = makeDismissable();

const ShowOnPath = ({ children, path }) => {
  const match = useMatch(path);

  return match ? children : null;
};

export const NewRequestsNotification = () => {
  const shouldShow = useSelector(hasMultipleSupport);
  if (!shouldShow) {
    return null;
  }

  return (
    <Dismissable>
      {(dismiss) => (
        <ShowOnPath path="/home">
          <NewRequestsNotificationContent onClick={dismiss} />
        </ShowOnPath>
      )}
    </Dismissable>
  );
};
